/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lasteditorid3Inputs */

const de__field_lasteditorid3 = /** @type {(inputs: _Field_Lasteditorid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Bearbeiter-ID`)
};

/**

* @param {_Field_Lasteditorid3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lasteditorid3 = /** @type {((inputs?: _Field_Lasteditorid3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lasteditorid3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lasteditorid3(inputs)
});
export { _field_lasteditorid3 as "_field_lastEditorID" }